import getSentry from '@buzzfeed/buzzblocks/js/services/sentry';

getSentry({
  env: window.Config.env,
  canary: window.Config.canaryDeploy,
  url: window.Config.sentryUrl,
  sampleRate: 0.05,
  ignoreErrors: []
});



// WEBPACK FOOTER //
// /app/static/js/tracking/sentry.js